/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
export const DeviceTableHeaders = [{
  id: "name",
  content: "name",
  className: "w-[22rem] max-w-[22rem]",
  ischecked: true,
  canSort: true,
  visible: true,
  removable: false
}, {
  id: "systemNumber",
  content: "systemNumber",
  className: "w-[16rem] max-w-[16rem]",
  ischecked: true,
  canSort: true,
  visible: true,
  removable: true
}, {
  id: "status",
  content: "status",
  className: "w-[12rem] max-w-[12rem]",
  ischecked: true,
  canSort: false,
  visible: true,
  removable: true
}, {
  id: "gatewayType",
  content: "gatewayType",
  ischecked: true,
  className: "w-[17rem] max-w-[17rem]",
  canSort: true,
  visible: true,
  removable: true
}, {
  id: "connectivityType",
  content: "connectivityType",
  ischecked: true,
  className: "w-[17rem] max-w-[17rem]",
  canSort: true,
  visible: true,
  removable: true
}, {
  id: "organizationName",
  content: "organization",
  ischecked: true,
  className: "w-[13rem] max-w-[13rem]",
  canSort: true,
  visible: true,
  removable: true
}, {
  id: "site",
  content: "site",
  className: "w-[13rem] max-w-[13rem]",
  ischecked: true,
  canSort: false,
  visible: true,
  removable: true
}, {
  id: "registrationTime",
  content: "registeredOn",
  className: "w-[14rem] max-w-[14rem]",
  ischecked: true,
  canSort: true,
  visible: true,
  removable: true
}, {
  id: "actions",
  content: "actions",
  className: "w-[150px] max-w-[150px]",
  ischecked: true,
  canSort: false,
  visible: true,
  removable: false
}];

export const getDeviceTableHeaders = (convertFn: (val: string) => string) => {
  return DeviceTableHeaders.map((header) => {
    return {
      ...header,
      content: convertFn(header.content)
    };
  });
};

export const comboOptionValue = [
  { label: "Second(s)", value: "seconds" },
  { label: "Minute(s)", value: "minutes" },
  { label: "Hour(s)", value: "hours" }
];

export const overviewTableTableHeaders = (isEdit: boolean, convertFn: (val: string) => string) => {
  let obj = [{
    id: "checkbox",
    content: "checkbox",
    className: "w-30",
    ischecked: false,
    canSort: false,
    visible: true,
    removable: false
  }, {
    id: "name",
    content: convertFn("name"),
    className: "w-90",
    ischecked: true,
    canSort: false,
    visible: true,
    removable: false
  }];

  if (isEdit) {
    obj.push({
      id: "action",
      content: convertFn("actions"),
      className: "w-10",
      ischecked: true,
      canSort: false,
      removable: false,
      visible: !isEdit || false
    });
  }

  return obj;
};

export const AssignSiteTableHeaders = [{
  id: "name",
  content: "name",
  className: "w-70",
  ischecked: true,
  canSort: true,
  visible: true,
  removable: false
}];

export const bulkAssignmentSiteTableHeaders = [{
  id: "name",
  content: "Name",
  className: "w-90",
  ischecked: true,
  canSort: false,
  visible: true,
  removable: false
}, {
  id: "action",
  content: "Action",
  className: "w-10",
  ischecked: true,
  canSort: false,
  removable: false,
  visible: false
}];

//filter keys for device types
export const filterKeysEbi = [
  'name',
  'status',
  'firmware-version',
  'protocol',
  'manufacturer',
  'model',
  'type',
  'firmware-revision',
  'description',
  'vendor-name',
  'protocol-revision'
];

export const filterKeysNiagara = [
  'name',
  'status',
  'firmware-version',
  'protocol',
  'manufacturer',
  'model',
  'type',
  'firmware-revision',
  'description',
  'vendor-name',
  'protocol-revision'
];

// Will update after API Integration to Correct Keys
export const LinkedDeviceTableHeadersEbi = [
  {
    "canSort": true,
    "className": "w-64",
    "content": "Name",
    "id": "name",
    "ischecked": true,
    "removable": false,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[12rem] max-w-[12rem]",
    "content": "Status",
    "id": "status",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "Firmware Version",
    "id": "firmware-version",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "Protocol",
    "id": "protocol",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "Manufacturer",
    "id": "manufacturer",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "Model",
    "id": "model",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "Type",
    "id": "type",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "Firmware Revision",
    "id": "firmware-revision",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "Description",
    "id": "description",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "Vendor Name",
    "id": "vendor-name",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "Protocol Revision",
    "id": "protocol-revision",
    "ischecked": false,
    "removable": true,
    "visible": false
  }

];

// Will update after API Integration to Correct Keys
export const LinkedDeviceTableHeadersNiagara = [
  {
    "canSort": true,
    "className": "w-64",
    "content": "Name",
    "id": "name",
    "ischecked": true,
    "removable": false,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[12rem] max-w-[12rem]",
    "content": "Status",
    "id": "status",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "Firmware Version",
    "id": "firmware-version",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "Protocol",
    "id": "protocol",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "Manufacturer",
    "id": "manufacturer",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "Model",
    "id": "model",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "Type",
    "id": "type",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "Firmware Revision",
    "id": "firmware-revision",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "Description",
    "id": "description",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "Vendor Name",
    "id": "vendor-name",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "Protocol Revision",
    "id": "protocol-revision",
    "ischecked": false,
    "removable": true,
    "visible": false
  }

];

export const headerStringsEBI: { [key: string]: string } = {
  name: "Name",
  status: "Status",
  "firmware-version": "Firmware Version",
  protocol: "Protocol",
  manufacturer: "Manufacturer",
  model: "Model",
  type: "Type",
  "firmware-revision": "Firmware Revision",
  description: "Description",
  "vendor-name": "Vendor Name",
  "protocol-revision": "Protocol Revision"
};

export const headerStringsNiagara: { [key: string]: string } = {
  name: "Name",
  status: "Status",
  "firmware-version": "Firmware Version",
  protocol: "Protocol",
  manufacturer: "Manufacturer",
  model: "Model",
  type: "Type",
  "firmware-revision": "Firmware Revision",
  description: "Description",
  "vendor-name": "Vendor Name",
  "protocol-revision": "Protocol Revision"
};

//<-- ebiHeaderData
export const ebiHeaderData = [
  {
    "canSort": true,
    "className": "w-64",
    "content": "name",
    "id": "name",
    "ischecked": true,
    "removable": false,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[12rem] max-w-[12rem]",
    "content": "status",
    "id": "status",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "firmwareVersion",
    "id": "firmware-version",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "protocol",
    "id": "protocol",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "manufacturer",
    "id": "manufacturer",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "model",
    "id": "model",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "type",
    "id": "type",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "firmwareRevision",
    "id": "firmware-revision",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "description",
    "id": "description",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "vendorName",
    "id": "vendor-name",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "protocolRevision",
    "id": "protocol-revision",
    "ischecked": false,
    "removable": true,
    "visible": false
  }
];

//<-- niagaraHeaderData
export const niagaraHeaderData = [
  {
    "canSort": true,
    "className": "w-64",
    "content": "name",
    "id": "name",
    "ischecked": true,
    "removable": false,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[12rem] max-w-[12rem]",
    "content": "status",
    "id": "status",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "firmwareVersion",
    "id": "firmware-version",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "protocol",
    "id": "protocol",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "manufacturer",
    "id": "manufacturer",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "modelName",
    "id": "model",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "type",
    "id": "type",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "firmwareRevision",
    "id": "firmware-revision",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "description",
    "id": "description",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "vendorName",
    "id": "vendor-name",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "protocolRevision",
    "id": "protocol-revision",
    "ischecked": false,
    "removable": true,
    "visible": false
  }
];

//<-- lowCostGatewayHeaderData
export const lowCostGatewayHeaderData = [
  {
    "canSort": true,
    "className": "w-64",
    "content": "name",
    "id": "name",
    "ischecked": true,
    "removable": false,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[12rem] max-w-[12rem]",
    "content": "status",
    "id": "status",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "firmwareVersion",
    "id": "firmware-version",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "protocol",
    "id": "protocol",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "manufacturer",
    "id": "manufacturer",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "modelName",
    "id": "model",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "type",
    "id": "type",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "firmwareRevision",
    "id": "firmware-revision",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "description",
    "id": "description",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "vendorName",
    "id": "vendor-name",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "protocolRevision",
    "id": "protocol-revision",
    "ischecked": false,
    "removable": true,
    "visible": false
  }
];

//<-- alertonGatewayHeaderData
export const alertonGatewayHeaderData = [
  {
    "canSort": true,
    "className": "w-64",
    "content": "name",
    "id": "name",
    "ischecked": true,
    "removable": false,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[12rem] max-w-[12rem]",
    "content": "status",
    "id": "status",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "firmwareVersion",
    "id": "firmware-version",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "protocol",
    "id": "protocol",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "manufacturer",
    "id": "manufacturer",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "modelName",
    "id": "model",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "type",
    "id": "type",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "firmwareRevision",
    "id": "firmware-revision",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "description",
    "id": "description",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "vendorName",
    "id": "vendor-name",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "protocolRevision",
    "id": "protocol-revision",
    "ischecked": false,
    "removable": true,
    "visible": false
  }
];


//<-- linked devices connect tab header adata
export const linkedDevicesConnected = [
  {
    "canSort": true,
    "className": "w-40",
    "content": "Name",
    "id": "name",
    "ischecked": true,
    "removable": false,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[10 rem] max-w-[10rem]",
    "content": "Protocol",
    "id": "protocol",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[8rem] max-w-[8rem]",
    "content": "MAC ID",
    "id": "mac_id",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[10rem] max-w-[10rem]",
    "content": "Local IP",
    "id": "host",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[10rem] max-w-[10rem]",
    "content": "Local Port",
    "id": "port",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[10rem] max-w-[10rem]",
    "content": "Usage",
    "id": "port_usage",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[9rem] max-w-[9rem]",
    "content": "Health",
    "id": "health_status",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[8rem] max-w-[8rem]",
    "content": "Connections",
    "id": "connections",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[8rem] max-w-[8rem]",
    "content": "Authorisation",
    "id": "auth_status",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[13rem] max-w-[13rem]",
    "content": "Actions",
    "id": "actions",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
];

//<-- linked devices connect tab header adata
export const gatewayPortsHeaderData = [
  {
    "canSort": true,
    "className": "w-[8rem] max-w-[8rem]",
    "content": "Local Port",
    "id": "port",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
{
    "canSort": true,
    "className": "w-[8rem] max-w-[8rem]",
    "content": "Usage",
    "id": "port_usage",
    "ischecked": true,
    "removable": true,
    "visible": true
  },

  {
    "canSort": true,
    "className": "w-[3rem] max-w-[3rem]",
    "content": "Authorisation",
    "id": "auth_status",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  {
    "canSort": true,
    "className": "w-[3rem] max-w-[3rem]",
    "content": "Actions",
    "id": "actions",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
];

//<-- Active devices connect tab header adata

export const activeConnectionConnected = [
  {
    "canSort": true,
    "className": "w-w-[6 rem] max-w-[7rem]",
    "content": "Client",
    "id": "client_id",
    "ischecked": true,
    "removable": false,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[7 rem] max-w-[8rem]",
    "content": "User",
    "id": "user_id",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[21 rem] max-w-[22rem]",
    "content": "Timestamp",
    "id": "connected_at",
    "ischecked": true,
    "removable": true,
    "visible": true
  },
  {
    "canSort": true,
    "className": "w-[21 rem] max-w-[22rem]",
    "content": "Duration",
    "id": "duration",
    "ischecked": false,
    "removable": true,
    "visible": false
  },
  // {
  //   "canSort": true,
  //   "className": "w-[7 rem] max-w-[8rem]",
  //   "content": "Actions",
  //   "id": "actions",
  //   "ischecked": false,
  //   "removable": true,
  //   "visible": false
  // },
];
  



